import Modal, { DialogBody, DialogFooter } from './Dialog';
import Button from './Button';

// Conferma per le azioni che non si possono annullare.
export default function ConfirmDialog({
  open, onClose, onConfirm, title, message, confirmLabel = 'Conferma',
  cancelLabel = 'Annulla', danger = false, loading = false,
}) {
  return (
    <Modal open={open} onClose={onClose} label={title} size="sm">
      <DialogBody><p className="text-sm text-ink">{message}</p></DialogBody>
      <DialogFooter>
        <Button variant="ghost" onClick={onClose}>{cancelLabel}</Button>
        <Button data-autofocus variant={danger ? 'danger' : 'primary'} loading={loading} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogFooter>
    </Modal>
  );
}
